/**
 * 添付ビューアの操作バー(2026-09-10 発注者指示)。
 * - 複数ページのPDF: ◁ ▷ でページを送る(いま何ページ目かを「3 / 20」で出す)
 * - 拡大縮小: − と ＋ で25%ずつ。いまの倍率を%で出す。「全体」で画面に収まる大きさへ戻す
 * PCでもスマホでも同じ形。指で押せるよう十分な大きさにする。
 */
export const ZOOM_MIN = 0.5;
export const ZOOM_MAX = 6;
export const ZOOM_STEP = 0.25;

export function clampZoom(v: number): number {
  return Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(v * 100) / 100));
}

export default function ViewerControls({
  page,
  pages,
  onPage,
  zoom,
  onZoom,
}: {
  /** 1始まり。ページ送りが不要(画像・1ページPDF)のときは pages=1 */
  page?: number;
  pages?: number;
  onPage?: (next: number) => void;
  zoom: number;
  onZoom: (next: number) => void;
}) {
  const multi = (pages ?? 1) > 1 && page != null && onPage != null;
  const btn: React.CSSProperties = {
    minWidth: 40,
    height: 34,
    padding: '0 10px',
    fontSize: 15,
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        flexWrap: 'wrap',
        padding: '8px 6px',
        borderTop: '1px solid var(--line)',
        background: '#fff',
        flexShrink: 0,
      }}
    >
      {multi && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <button className="btn-line" style={btn} disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label="前のページ">
            ◁
          </button>
          <span style={{ minWidth: 70, textAlign: 'center', fontSize: 13.5, fontVariantNumeric: 'tabular-nums' }}>
            {page} / {pages}
          </span>
          <button
            className="btn-line"
            style={btn}
            disabled={page >= (pages ?? 1)}
            onClick={() => onPage(page + 1)}
            aria-label="次のページ"
          >
            ▷
          </button>
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button
          className="btn-line"
          style={btn}
          disabled={zoom <= ZOOM_MIN}
          onClick={() => onZoom(clampZoom(zoom - ZOOM_STEP))}
          aria-label="縮小"
        >
          −
        </button>
        <span style={{ minWidth: 58, textAlign: 'center', fontSize: 13.5, fontVariantNumeric: 'tabular-nums' }}>
          {Math.round(zoom * 100)}%
        </span>
        <button
          className="btn-line"
          style={btn}
          disabled={zoom >= ZOOM_MAX}
          onClick={() => onZoom(clampZoom(zoom + ZOOM_STEP))}
          aria-label="拡大"
        >
          ＋
        </button>
        <button className="btn-line" style={{ ...btn, minWidth: 56 }} onClick={() => onZoom(1)}>
          全体
        </button>
      </div>
    </div>
  );
}
